import * as React from 'react';
const SvgChevronRight = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 13 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 17.151 2.899 20 13 10.009 2.899 0 .035 2.815 7.35 10z" />
  </svg>
);
export default SvgChevronRight;
